import { gsap } from 'gsap';

export default class MenuItem {
  constructor(menuItem, options = {}) {
    this.defaultOptions = {};
    this.options = { ...this.defaultOptions, ...options };

    this.dom = {
      menuItem,
      line: menuItem.querySelector('.line'),
      chars: menuItem.querySelectorAll('.char'),
      lineClone: '',
      lineCloneChars: undefined,
    };

    this.data = {
      menuItemEnter: new Event('menuItemEnter'),
      menuItemLeave: new Event('menuItemLeave'),
      timelineText: undefined,
      timelineTextDefaults: {
        defaults: {
          duration: 0.5,
          ease: 'power2.inOut',
          stagger: {
            amount: 0.1,
          },
        },
      },
    };

    this.mount();
  }

  mount() {
    this.cloneLines();

    this.dom.menuItem.addEventListener('mouseenter', () => this.onMouseEnter());
    this.dom.menuItem.addEventListener('mouseleave', () => this.onMouseLeave());
  }

  cloneLines() {
    this.dom.lineClone = this.dom.line.cloneNode(true);
    this.dom.lineClone.classList.add('line--clone');
    this.dom.lineCloneChars = this.dom.lineClone.querySelectorAll('.char');
    this.dom.menuItem.appendChild(this.dom.lineClone);
  }

  onMouseEnter() {
    this.animateTextIn();
    if (this.dom.menuItem.dataset.img) this.dom.menuItem.dispatchEvent(this.data.menuItemEnter);
  }

  onMouseLeave() {
    this.animateTextOut();
    if (this.dom.menuItem.dataset.img) this.dom.menuItem.dispatchEvent(this.data.menuItemLeave);
  }

  animateTextIn() {
    this.data.timelineText = gsap.timeline(this.data.timelineTextDefaults)
      .to(this.dom.chars, {
        y: '40%',
        rotationX: -90,
        opacity: 0,
      })
      .to(this.dom.lineCloneChars, {
        startAt: { y: '-40%', rotationX: 90, opacity: 0 },
        y: '0%',
        rotationX: 0,
        opacity: 1,
      }, 0.1);
  }

  animateTextOut() {
    if (this.data.timelineText) this.data.timelineText.kill();

    this.data.timelineText = gsap.timeline(this.data.timelineTextDefaults)
      .to(this.dom.lineCloneChars, {
        y: '-40%',
        rotationX: 90,
        opacity: 0,
      })
      .to(this.dom.chars, {
        startAt: { y: '40%', rotationX: -90, opacity: 0 },
        y: '0%',
        rotationX: 0,
        opacity: 1,
      }, 0.1);
  }
}
